const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaTagInputCtrl = function ($scope, $routeParams, dataService) {
    const vm = this;
    const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

    vm.data = _.get(dataService.data.activeItem, dataLookUp);
    vm.itemArray = [];
    vm.copyStatus = 'Copy all tags to clipboard';
    vm.copyItems = copyItems;
    vm.validationLimit = vm.settings.validationItemLimit;
    vm.validationPattern = vm.settings.validationRegex;
    vm.isValid = true;
    // Preserve any static help text configured for this field
    vm.originalHelpText = vm.settings.helpText;

    function copyTextToClipboard(text) {
        const textArea = document.createElement("textarea");

        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;

       document.body.appendChild(textArea);

        textArea.select();

        try {
            document.execCommand('copy');
        } catch (err) {

        }

        document.body.removeChild(textArea);
    }

    function copyItems() {
       copyTextToClipboard(vm.data.join(', '));
    }

    $scope.$watchCollection('vm.data', (newData, oldData) => {
        if (newData !== oldData) {

            if (vm.validationPattern) {
                let regex = new RegExp(vm.validationPattern);
                vm.isValid = regex.test(vm.data);
                $scope.$emit('ValidationStatusChanged', {
                    controllerName: $scope.vm.settings.dataAt,
                    isValid: vm.isValid
                });
                // Do not override helpText here; the template will show
                // validationMessage when invalid, and helpText otherwise.
            }

            // TODO: Put this into it's own component or utility to reuse.
            if (vm.validationLimit) {
                let itemCount = vm.data.length;
                vm.isValid = !itemCount || itemCount <= vm.validationLimit; 
                $scope.$emit('ValidationStatusChanged', {
                    controllerName: $scope.vm.settings.dataAt,
                    isValid: vm.isValid
                });
                // Do not override helpText here either.
            }

            _.set(dataService.data.activeItem, dataLookUp, newData);
        }
    });

    vm.taggingFunc = function (event) {
        event.preventDefault();
        let re = /\r?\n|\r/g;
        let pasted = event.originalEvent.clipboardData.getData('text/plain').replace(re, '').trim();
        let arr = [];   
        let end = 0;

        for (let start = 0; start < pasted.length; start++) {
            let isValidString = pasted[start];
            if (isValidString === ' ' || isValidString === ',') continue;

            if (pasted.startsWith('<regex>', start)) {            
                end = pasted.indexOf('</regex>', start) + 8;            
                arr.push(pasted.slice(start, end));
                start = end;
            } else {
                end = pasted.indexOf(',', start);
                if (end === -1) end = pasted.length;
                arr.push(pasted.slice(start, end));
                start = end;
            }
        }
        
        vm.data = _.uniq(_.union(vm.data, arr));
    }
};

lbaTagInputCtrl.$inject = $inject;

export default lbaTagInputCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaTagInput/lbaTagInputCtrl.js